import { Icon, type IconProps } from "@chakra-ui/icon";

function BellIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity="0.12"
				d="M12 5.83333C12 4.77247 11.5785 3.75505 10.8284 3.00491C10.0783 2.25476 9.06084 1.83333 7.99997 1.83333C6.93911 1.83333 5.92169 2.25476 5.17154 3.00491C4.4214 3.75505 3.99997 4.77247 3.99997 5.83333C3.99997 7.89346 3.48029 9.30397 2.89975 10.2369C2.41006 11.0239 2.16521 11.4174 2.17419 11.5272C2.18413 11.6487 2.20988 11.6951 2.30782 11.7677C2.39628 11.8333 2.79503 11.8333 3.59254 11.8333H12.4074C13.2049 11.8333 13.6037 11.8333 13.6921 11.7677C13.7901 11.6951 13.8158 11.6487 13.8258 11.5272C13.8347 11.4174 13.5899 11.0239 13.1002 10.2369C12.5197 9.30397 12 7.89346 12 5.83333Z"
				fill="currentColor"
			/>
			<path
				d="M9.3333 14.5H6.66664M12 5.83333C12 4.77247 11.5785 3.75505 10.8284 3.00491C10.0783 2.25476 9.06084 1.83333 7.99997 1.83333C6.93911 1.83333 5.92169 2.25476 5.17154 3.00491C4.4214 3.75505 3.99997 4.77247 3.99997 5.83333C3.99997 7.89346 3.48029 9.30397 2.89975 10.2369C2.41006 11.0239 2.16521 11.4174 2.17419 11.5272C2.18413 11.6487 2.20988 11.6951 2.30782 11.7677C2.39628 11.8333 2.79503 11.8333 3.59254 11.8333H12.4074C13.2049 11.8333 13.6037 11.8333 13.6921 11.7677C13.7901 11.6951 13.8158 11.6487 13.8258 11.5272C13.8347 11.4174 13.5899 11.0239 13.1002 10.2369C12.5197 9.30397 12 7.89346 12 5.83333Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default BellIcon;
